import styled from 'styled-components';

/* Mixins */
import { FlexCenterChildren } from 'styles/Mixins';

/* Utils */
import { assignIfDefined, opaque } from 'styles/Utils';

export const Radio = styled.div.attrs({ role: 'radio' })<{
  selected?: boolean;
  margin?: string;
  borderColor?: string;
}>`
  width: 16px;
  height: 16px;
  border: 2px solid
    ${({ selected, borderColor, theme }) =>
      selected ? borderColor || theme.primaryColor : theme.Grey5};
  border-radius: 50%;
  ${assignIfDefined('margin')};
  ${FlexCenterChildren};
  flex-shrink: 0;
`;

export const RadioDot = styled.div<{
  selected?: boolean;
  color?: string;
}>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  ${({ selected, theme, color }) =>
    selected && `background-color: ${color || theme.primaryColor}`};
  transition: linear 0.1s background-color;
`;

export const RadioOption = styled.div<{
  alignItems?: string;
  backgroundColor?: string;
  padding?: string;
  borderBottom?: string;
  fontSize?: string;
  color?: string;
  marginBottom?: string;
}>`
  display: flex;
  cursor: pointer;
  flex-shrink: 0;
  align-items: ${({ alignItems }) => alignItems || 'center'};
  ${({ backgroundColor }) =>
    backgroundColor && `background-color:${backgroundColor}`};
  ${assignIfDefined('padding')};
  ${assignIfDefined('borderBottom', 'border-bottom')};
  ${assignIfDefined('fontSize', 'font-size')};
  ${assignIfDefined('color')}
  ${assignIfDefined('marginBottom', 'margin-bottom')}
`;

export const HorizontalRule = styled.hr`
  width: calc(100% + 48px);
  margin: 16px -24px 0px -24px;
  border-color: ${({ theme }) => opaque(theme.Grey6, 0.15)};
`;
